// Track production metadata
export interface TrackProductionMetadata {
  trackName: string;
  baseSong?: string;
  effects?: string[];
  instrumentalFile?: string; // Path to instrumental/background MP3
  notes?: string;
}

// Production metadata for tracks
// Add entries here as you create new songs
export const TRACK_METADATA: Record<string, TrackProductionMetadata> = {
  // Example entries - replace with your actual track metadata
  // "Your Track Name": {
  //   baseSong: "Original Song Name (slowed)",
  //   effects: ["Reverb", "Slowed", "Bass Boost"],
  //   instrumentalFile: "/audio/full/instrumental_track_name.mp3",
  //   notes: "Additional production notes"
  // },
  
  // Add your tracks here following this format:
  // The trackName should match the exact name from Spotify
};

// Helper function to get metadata for a track
export const getTrackMetadata = (trackName: string): TrackProductionMetadata | null => {
  return TRACK_METADATA[trackName] || null;
};

// Helper function to check if a track has production metadata
export const hasTrackMetadata = (trackName: string): boolean => {
  return trackName in TRACK_METADATA;
};

